import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{attrs:{"id":"city-get"}},[(_vm.isAuthenticated)?_c('sala-municipio-header',{attrs:{"payload":_vm.payload}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }